import { defineStore } from 'pinia'
import http from '../helpers/http-call'
import {
  ENDPOINT_URL,
  getDataLang,
  getQuery,
} from '../helpers/api'

interface QueryProps {
  showData?: boolean
  headers?: {
    Authorization?: string
  }
  hotel_id?: number
  lang_id?: number
  page_size?: number
  page?: number
}
export interface GalleriesData {
  gallery: Array<Galleries>
}
export interface Galleries {
  gallery_groups: string
  gallery_image: string | null
}

export interface GalleriesState {
  list: Array<Galleries>
  data: GalleriesData
  dataSwiper: GalleriesData
  loading: boolean
  params: QueryProps
}

const PARAMS: QueryProps = {}

const DATA = {
  gallery: [],
}

export const useGalleriesStore = defineStore('galleries', {
  state: (): GalleriesState => ({
    list: [],
    loading: false,
    data: DATA,
    dataSwiper: DATA,
    params: PARAMS,
  }),
  getters: {
    getList(): Array<Galleries> {
      return getDataLang(this.list)
    },
    getData(): GalleriesState['data'] {
      return this.data
    },
  },
  actions: {
    async setList(data: Array<Galleries>) {
      this.list = data
    },
    async setData(query: QueryProps, isSwiper: boolean | undefined = false) {
      const {
        showData,
        headers,
      }: QueryProps = query
      const params = getQuery()
      this.params = params

      let data = DATA
      let response: any = {
        data: {},
      }
      if (!this.loading) {
        this.loading = true
        response = await http.call({
          url: `${ENDPOINT_URL}/hotel/${params.hotel_id}/gallery?lang_id=${params.lang_id}`,
          headers,
          method: 'GET',
          data: null,
        })
      }
      this.loading = false
      if (response?.data?.data)
        data = response.data?.data

      if (isSwiper)
        this.dataSwiper = data
      else
        this.data = data

      if (showData)
        return await data
    },
  },
})
